export default function roundX(value, precision = 0) {
  return Math.round(Math.round(value * Math.pow(10, (precision || 0) + 1)) / 10) / Math.pow(10, precision)
}
